import Category from '@/api/category';
import EntityView from '@/views/EntityView.vue';

export const CATEGORY_ROUTE = [
  {
    path: `/${Category.SLUG}/`,
    name: `${Category.SLUG}-list`,
    component: EntityView,
    props: () => ({
      entity: Category.SLUG
    }),

    meta: {
      title: 'Category · ELSA Content Creator'
    }
  },
  {
    path: `/${Category.SLUG}/new`,
    name: `${Category.SLUG}-new`,
    component: EntityView,
    props: () => ({
      entity: Category.SLUG,
      isNew: true,
      isEdit: true
    }),

    meta: {
      title: 'New Category · ELSA Content Creator'
    }
  },
  {
    path: `/${Category.SLUG}/:id(\\d+)`,
    name: `${Category.SLUG}-edit`,
    component: EntityView,
    props: (route) => ({
      entity: Category.SLUG,
      id: parseInt(route.params.id, 10),
      isEdit: true
    }),
    meta: {
      title: 'Edit Category · ELSA Content Creator'
    }
  }
];
